import { CompoundFilterStateOption } from '../../../../../../CompoundFilter.types';
import { resolveCompoundFilterStateModifiers } from '../../../../../../helpers';

export const getActiveCount = (options: CompoundFilterStateOption[]) => {
  const count = options.reduce((prev, curr) => {
    const { isActive } = resolveCompoundFilterStateModifiers(curr.stateModifiers);

    if (isActive) {
      return prev + 1;
    }

    return prev;
  }, 0);

  return count;
};
